import React, { useContext } from 'react';
import { TbCopyright } from "react-icons/tb";
import Socialmedia from './Socialmedia';
import { useTheme } from '../context/ThemeContext';
import { CursorContext } from '../context/CursorContext';

const Footer = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  const theme = useTheme();
  const darkMode = theme?.darkMode ?? true;

  return (
    <div className="w-full py-10 bg-transparent flex flex-col items-center gap-2">

      <Socialmedia />

      <p className={`text-xs flex items-center gap-[3px] mt-4 ${darkMode ? 'text-white/40' : 'text-slate-400'}`}>
        <TbCopyright size={12} />
        2023 Eden Kefale · All rights reserved.
      </p>

      <p className={`text-xs ${darkMode ? 'text-white/30' : 'text-slate-400'}`}>
        Designed and built by{' '}
        <a
          href="https://edenkefaleuiux.vercel.app/"
          target="_blank"
          rel="noreferrer"
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
          className={`underline transition ${darkMode ? 'text-white/50 hover:text-white' : 'text-slate-500 hover:text-black'}`}
        >
          Eden Kefale
        </a>
      </p>

    </div>
  );
};

export default Footer;